/* src/app/components/analytics/case-analytics/case-analytics.component.scss */
.analytics-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.analytics-card .mat-card-content {
  width: 100%;
  height: 100%;
}
.analytics-card .mat-card-content .analytics-graph-component {
  display: block;
  width: 100%;
  height: 100%;
}
.dark-theme .analytics-card {
  border: 1px solid rgba(255, 255, 255, 0.03);
}
.analytics-card-wrapper {
  min-width: 450px;
  min-height: 350px;
  height: 60vh;
  max-height: 480px;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 0.33%;
  padding: 8px;
}
#analytics-page-wrapper::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}
#analytics-page-wrapper::-webkit-scrollbar-thumb {
  -webkit-border-radius: 6px;
  background: #b1b1b1;
  background-clip: padding-box;
}
#analytics-header {
  font-size: 20px;
  padding: 16px 0 8px 35px;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;
  color: #7b7b7b;
  color: #727272;
  color: rgba(0, 0, 0, 0.7);
}
#analytics-header #analytics-icon {
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) #analytics-header {
  color: #b7b7b7;
}
:host-context(.dark-theme) #analytics-header #analytics-icon {
  color: #FFC107;
}
:host-context(.dark-theme) #analytics-header #analytics-name {
  color: #dbdbdb;
}
#no-uploads-message a {
  text-decoration: none;
}
#no-uploads-message .icon {
  color: #fff;
  font-size: 28px;
}
#no-uploads-message .primary-text {
  font-size: 22px;
  font-weight: 500;
}
#no-uploads-message .secondary-text {
  font-size: 18px;
}
#no-uploads-message mat-toolbar {
  background-color: var(--palette-primary-default);
}
#no-uploads-message button {
  background-color: var(--palette-primary-default);
  color: white;
  font-weight: 400;
  height: 40px;
  word-spacing: -0.1px;
  padding: 0;
  justify-content: center;
  width: 300px;
}
#no-uploads-message [body-subject] {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  word-spacing: -0.1px;
  font-size: 12px;
  justify-content: space-around;
  gap: 0px;
}
#no-uploads-message [body-subject] div {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 75%;
  padding-right: 8px;
  padding-left: 8px;
}
#no-uploads-message [body-subject] b {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 500;
  font-size: 14px;
  word-spacing: -0.2px;
  color: #fff;
}
#no-uploads-message [body-subject] i {
  width: 18%;
  height: 100%;
  border-left: 0px solid transparent;
  padding-right: 8px;
  font-size: 20px;
  color: #fff;
}
#no-uploads-message [body-subject] div {
  border-left: transparent;
}
#no-uploads-message [body-subject] div div:has(b) {
  border-left: 1px solid rgba(225, 240, 255, 0.5);
}
:host-context(.dark-theme) #no-uploads-message .icon {
  --fa-primary-color: #fff;
  --fa-secondary-color: #fff;
}
:host-context(.dark-theme) #no-uploads-message .primary-text {
  color: #fff;
}
:host-context(.dark-theme) #no-uploads-message .secondary-text {
  color: #a5a5a5;
}
:host-context(.dark-theme) #no-uploads-message mat-card {
  background: var(--secondary-background-theme);
}
/*# sourceMappingURL=case-analytics.component.css.map */
